const onRun = () => {
    // Trip Carousel and Fancybox
    const container = document.getElementById("myCarouselBanners");
    if (container !== null) {
        const options = {
            Dots: true,
            Thumbs: {
                type: "classic",
            },
            infinite: false
        };
        new Carousel(container, options, {Thumbs});
    }

    if (window.screen.width <= 991) {
        Fancybox.bind("[data-fancybox]", {
            Hash: false,
            Thumbs: false,
            Toolbar: {
                display: {
                    left: [''],
                    middle: ['infobar'],
                    right: ['close'],
                },
            },
        });
    } else {
        Fancybox.bind("[data-fancybox]", {
            Hash: false,
            Thumbs: {
                type: "classic",
            },
            Toolbar: {
                display: {
                    left: [''],
                    middle: ['infobar'],
                    right: ['close'],
                },
            },
        });
    }
};

if(document.readyState !== 'loading') {
    onRun();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        onRun()
    });
}
